import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Service} from 'src/app/enums/service.enum';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PosterDefinition} from 'src/app/model/poster-definition.model';
import {CustomHttpUrlEncodingCodec} from '../../../main/encoder';
@Injectable({
  providedIn: 'root',
})
export class PosterDefinitionService {
  private readonly posterDefinitionApi: string = environment.endPoint + ApplicationPackage.CMS_VOD + Service.POSTER_DEFINITION;

  constructor(private http: HttpClient) {}

  getAllPosterDefinitions(
    type?: string,
    platform?: string,
    name?: string,
    aspectRatio?: string,
    width?: number,
    height?: number,
    fileSize?: number,
    mandatoryPoster?: boolean,
    catalogPoster?: boolean,
    compressRatio?: number,
    sortParams?: string[],
  ): Observable<PosterDefinition[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (type) {
      queryParams = queryParams.set('type', <any>type);
    }
    if (platform) {
      queryParams = queryParams.set('platform', <any>platform);
    }
    if (name) {
      queryParams = queryParams.set('name', <any>name);
    }
    if (aspectRatio) {
      queryParams = queryParams.set('aspectRatio', <any>aspectRatio);
    }
    if (fileSize) {
      queryParams = queryParams.set('fileSize', <any>fileSize);
    }
    if (mandatoryPoster) {
      queryParams = queryParams.set('mandatoryPoster', <any>mandatoryPoster);
    }
    if (catalogPoster) {
      queryParams = queryParams.set('catalogPoster', <any>catalogPoster);
    }
    if (compressRatio) {
      queryParams = queryParams.set('compressRatio', <any>compressRatio);
    }
    if (width) {
      queryParams = queryParams.set('width', <any>width);
    }
    if (height) {
      queryParams = queryParams.set('height', <any>height);
    }
    if (sortParams != undefined && sortParams != null) {
      queryParams = queryParams.set('sortParam', <any>sortParams);
    }
    return this.http.get<PosterDefinition[]>(this.posterDefinitionApi, {params: queryParams});
  }

  getPosterDefinitonById(id: number): Observable<PosterDefinition> {
    return this.http.get<PosterDefinition>(`${this.posterDefinitionApi}/${id}`);
  }

  setAsCatalogPoster(posterDefinitionId: number): Observable<string> {
    return this.http.post<string>(this.posterDefinitionApi + `/${posterDefinitionId}/catalog`, null);
  }
  setAsMandatory(posterDefinitionId: number): Observable<string> {
    return this.http.post<string>(this.posterDefinitionApi + `/${posterDefinitionId}/mandatory`, null);
  }

  unsetAsMandatoryPoster(posterDefinitionId: number): Observable<string> {
    return this.http.post<string>(this.posterDefinitionApi + `/${posterDefinitionId}/nonmandatory`, null);
  }

  setCompressRatio(posterDefinitionId: number, compressRatio: number): Observable<string> {
    return this.http.put<string>(this.posterDefinitionApi + `/${posterDefinitionId}/compressratio`, compressRatio, {
      responseType: 'text' as 'json',
    });
  }
}
